import mixpanel from 'mixpanel-browser'

// let env_check = process.env.NODE_ENV === 'production';
class ApAnalytics {
  constructor() {
    mixpanel.init(process.env.REACT_APP_MIX_PANEL_KEY)
    // console.log('env', process.env)
    // console.log('mixpanel', mixpanel)
  }

  trackData = (trackingDetail, props) => {
    const {user} = props
    mixpanel.track(`${trackingDetail.toLowerCase().replace('_', ' ')}`)
    this.identify(user.id)
    this.setPeople({
      $first_name: user.first_name,
      $last_name: user.last_name,
    })
  }

  identify = id => {
    mixpanel.identify(id)
  }

  setPeople = props => {
    mixpanel.people.set(props)
  }
}

const mixPanelInstance = new ApAnalytics()

Object.freeze(mixPanelInstance)

export default mixPanelInstance
